<template>
  <tr>
    <td>
      <div v-if="!isPackItem" class="td-wrapper td-wrapper-status">
        <div>
          {{ moment(created_at).format("DD.MM.YYYY") }}
        </div>
        <div class="status">{{ status }}</div>
      </div>
    </td>
    <td>
      <div class="td-wrapper">
        <div class="img-container">
          <img
            v-if="itemData.product_type === 'image'"
            class="img"
            :src="imgDomain + itemData.doc_url"
          />
          <div v-else-if="itemData.product_type === 'doc'" class="doc-img">
            <img src="./../assets/doc.svg" class="image" />
          </div>
          <ImageGrid
            v-else-if="isPack"
            :img-domain="imgDomain"
            :images="imagePaths"
          />
        </div>
      </div>
    </td>
    <td>
      <div class="td-wrapper">
        {{ itemData.title }}
      </div>
    </td>
    <td>
      <div v-if="!isPack" class="td-wrapper td-wrapper-btns">
        <div class="options">
          <select
            v-if="dimensions && dimensions.length > 1"
            v-model="localDownloadSize"
            @change="emitSize"
          >
            <option v-for="(item, i) in dimensions" :key="i" :value="item">
              {{ item }}
            </option>
          </select>
          <select
            v-if="formatOptions && itemData.product_type === 'image'"
            v-model="localDownloadFormat"
            @change="emitFormat"
          >
            <option v-for="(item, i) in formatOptions" :key="i" :value="item">
              {{ item }}
            </option>
          </select>
          <select
            v-if="formatOptions && itemData.product_type === 'doc'"
            v-model="localDownloadFormatDoc"
            @change="emitFormatDoc"
          >
            <option
              v-for="(item, i) in formatOptions"
              :key="'a' + i"
              :value="item"
            >
              {{ item }}
            </option>
          </select>
        </div>
      </div>
    </td>
    <td class="price">
      <div v-if="!isPackItem" class="td-wrapper">
        {{ price }} {{ currency }}
      </div>
    </td>
    <td>
      <div v-if="!isPack && status.toLowerCase() == 'success'" class="td-wrapper td-wrapper-btns">
        <div class="btn blue" @click="downloadProduct()">
          <img src="./../assets/download.svg" class="img" />
        </div>
      </div>
    </td>
  </tr>
</template>

<script>
import moment from "moment";
import ImageGrid from "@/components/ImageGrid.vue";

export default {
  name: "OrderHistoryRow",
  components: { ImageGrid },
  props: {
    isPackItem: {
      type: Boolean,
      default: () => false,
    },
    itemData: Object,
    status: String,
    created_at: String,
    dimensions: Array,
    price: [Number, String],
    imgDomain: String,
    currency: String,
    formatOptions: Array,
    activeDownloadSize: String,
    activeDownloadFormat: String,
    activeDocDownloadFormat: String,
  },
  data() {
    return {
      localDownloadSize: this.activeDownloadSize,
      localDownloadFormat: this.activeDownloadFormat,
      localDownloadFormatDoc: this.activeDocDownloadFormat,
      imgDomainInternal: process.env.VUE_APP_STATIC_DOMAIN,
    };
  },
  watch: {
    activeDownloadSize(val) {
      this.localDownloadSize = val;
    },
    activeDownloadFormat(val) {
      this.localDownloadFormat = val;
    },
    activeDocDownloadFormat(val) {
      this.localDownloadFormatDoc = val;
    },
  },
  computed: {
    isPack() {
      return this.itemData.product_type === "pack";
    },
    imagePaths() {
      return (this.itemData.pack_items || []).map((image) => image.doc_url);
    },
  },
  methods: {
    moment,
    emitSize() {
      this.$emit("update:activeDownloadSize", this.localDownloadSize);
    },
    emitFormat() {
      this.$emit("update:activeDownloadFormat", this.localDownloadFormat);
    },
    emitFormatDoc() {
      this.$emit("update:activeDocDownloadFormat", this.localDownloadFormatDoc);
    },
    downloadProduct() {
      const data = { ...this.itemData };

      if (this.isPackItem) {
        data["product_type"] = "pack";
      }

      this.$emit("download", data);
    },
  },
};
</script>
